export const EXPENSE_TYPE_FIELDS = [
  "date",
  "description",
  "unit",
  "supplier",
  "category",
  "staff_name",
  "price",
  "quantity",
];

export const EXPENSE_TYPE_FIELD_OPTIONS = [
  { label: "Date", value: "date" },
  { label: "Description", value: "description" },
  { label: "Quantity", value: "quantity" },
  { label: "Price", value: "price" },
  { label: "Unit", value: "unit" },
  { label: "Staff Name", value: "staff_name" },
  { label: "Supplier", value: "supplier" },
];
